import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IState } from './types';

// --------------------------------------------

export const initialState: IState = {
  token: '',
  recentViewedRecipes: [],
};

const slice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
    },
    saveViewedRecipe(state, action: PayloadAction<any>) {
      const { payload } = action;
      const exists = state.recentViewedRecipes.find((item) => item.uri === payload.uri);
      if (!exists) {
        state.recentViewedRecipes = [payload, ...state.recentViewedRecipes].slice(0, 20);
      }
    },
  },
});

export default slice.reducer;

export const { setToken, saveViewedRecipe } = slice.actions;
